export default "__VITE_ASSET__BtlmHdz0__"